import { render, staticRenderFns } from "./DpaAccountViewGlobal.vue?vue&type=template&id=15542441&"
import script from "./DpaAccountViewGlobal.vue?vue&type=script&lang=js&"
export * from "./DpaAccountViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports